import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { IProfile } from '../../../../../../services/common/profile'
import { UserEvents } from '../../user-events'

const mParticleEvents: any = new UserEvents()

export const SetAttributes = (result?: any, profile?: IProfile, meta?: any) => {

    if (profile) {
        // Set if the user age gated - must be a string value
        if (profile.ageGated) {
            mParticleEvents.setUserAttribute(key.USER_CLAIMED_19_PLUS, String(profile.ageGated))
        }
        // Set user's province into mParticle
        if (profile.province) {
            mParticleEvents.setUserAttribute(key.USER_PROVINCE, String(profile.province))
        }

        // Set user's postal code into mParticle
        if (profile.postalCode) {
            mParticleEvents.setUserAttribute(key.USER_PST_CDE, String(profile.postalCode))
        }
    }

    if (meta) {
        const brandAttrs = [key.BRAND, key.DIVISION, key.DISTRIBUTOR, key.VENDOR]
        brandAttrs.forEach((item) => {
            if (meta[item]) {
                mParticleEvents.setUserAttribute(item, String(meta[item]))
            }
        })
    }

    if (result) {
        // Set mParticle ID as user attribute
        const mParticleID = String(result.body.mpid)
        if (mParticleID) {
            if (profile) {
                profile.mpId = String(mParticleID)
            }
            mParticleEvents.setUserAttribute(key.USER_MPID, mParticleID)
        }
    }
}
